export default {
  install(Vue){
    Vue.filter('dateTime',(v, format = 'yyyy-mm-dd hh:ii', language, type)=>{
      if (v) {
        return dsf.date.format(v, format, language, type)
      }
      return '';
    })
  }
}